import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { useRef, useEffect } from 'react';
import useEffectOnce from 'hooks/useEffectOnce';
import { useHistory } from 'react-router-dom';
import './Policies.scss';

export default (props) => {
  const history = useHistory();
  const appendix = useRef(null);
  const clause6 = useRef(null);
  const clause13 = useRef(null);
  const [showTargetDateOne, setShowTargetDateOne] = useState(false);
  const [showTargetDateTwo, setShowTargetDateTwo] = useState(false);

  useEffect(() => {
    const scrollToTop = () => {
      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    scrollToTop();
  }, []);

  useEffectOnce(() => {
    if (history.location.hash.indexOf("products-list") > -1) {
      const section = document.querySelector('#products-list');
      if (section !== null) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    if (history.location.hash.indexOf("clause-6") > -1) {
      const section = document.querySelector('#clause-6');
      if (section !== null) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    if (history.location.hash.indexOf("clause-10") > -1) {
      const section = document.querySelector('#clause-10');
      if (section !== null) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    if (history.location.hash.indexOf("clause-11") > -1) {
      const section = document.querySelector('#clause-11');
      if (section !== null) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    if (history.location.hash.indexOf("clause-13") > -1) {
      const section = document.querySelector('#clause-13');
      if (section !== null) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  const scrollToSection = (selector) => {
    const section = document.querySelector(selector);
    if (section !== null) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const checkTime = () => {
      const targetDateOne = new Date("2025-06-02T00:01:00");
      const targetDateTwo = new Date("2025-07-01T00:01:00");
      const now = new Date();

      if (now >= targetDateOne) {
        setShowTargetDateOne(true);
      }

      if (now >= targetDateTwo) {
        setShowTargetDateTwo(true);
      }
    };

    checkTime();
    const interval = setInterval(checkTime, 60000);

    return () => clearInterval(interval);
  }, []);



  return <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Terms & Conditions | Cadbury FC - Game Changing Wins</title>
    </Helmet>
    <section className="layout-general layout-wrapper layout-general--full">
      <div className="layout-container layout-container--wide layout-container--center">
        <div className='policies'>
          <h1 className="type-h2">Terms & Conditions</h1>

          <div className='policies__content'>
            <br />
            <ol>
              <li>
                <p>This Promotion is open to residents of the United Kingdom and Republic of Ireland (excluding Channel Islands and Isle of Man) aged 18 or over, excluding employees of the Promoter, its agents and anyone professionally associated with this Promotion.</p>
              </li>

              <li>
                <p>Purchase is necessary for UK residents ONLY. <strong>Please retain an itemised receipt that states the time and date of purchase prior to entry, but within the Promotion Period, as this may be required for validation and in order for the winner to receive their Prize.</strong> Internet access, UK mobile number and a valid email address are required. </p>
              </li>

              <li>
                <p><strong>Promotion Period:</strong></p>
                <ol type="a">
                  <li><p><strong>Prize Draw and Winning Moments:</strong> Enter between 10:00 BST on the 28 April 2025 and 16:59 BST on the 28 July 2025 inclusive.</p></li>
                  <li><p><strong>Wrap Up Draw:</strong> Enter between 17:00 BST on the 28 July 2025 and 16:59 GMT on the 21 January 2026 inclusive.</p> </li>
                </ol>
              </li>

              <li>
                <p><strong>To Enter:</strong></p>
                <ol type='a'>
                  <li>
                    <p><strong>Level 1 Prize Draw</strong></p>
                    <ol type='i'>
                      <li><p><strong>UK:</strong> Purchase a Promotional Product, see <button type="button" className="button button--text-link" onClick={() => scrollToSection("#clause-6")}>clause 6</button> for a list of Promotional Products. Visit <a href="https://gamechanging.cadbury.co.uk" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.co.uk</a> and select your region. Complete the online form providing the bar code and batch code along with your details (full name, email address and mobile number) and choose your Participating Player and the Level 1 Prize Draw you would like to be entered into.</p></li>
                      <li><p><strong>ROI:</strong> Visit <a href="https://gamechanging.cadbury.ie" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.ie</a> and select your region. Complete the online form with your details (full name, email address, mobile number, full address including eircode) and choose your Participating Player and the Level 1 Prize Draw you would like to be entered into. You will receive a one-time passcode, submit passcode on-screen to verify entry into relevant Prize Draw via SMS.</p></li>
                    </ol>
                  </li>
                  <li>
                    <p><strong>Level 2/3 Winning Moments:</strong> All valid entries from UK and ROI are also submitted into a winning moments promotion.</p>
                  </li>
                  <li>
                    <p><strong>Wrap-Up Draw:</strong></p>
                    <ol type='i'>
                      <li><p><strong>UK:</strong> Purchase a Promotional Product within the Wrap-Up Draw Promotional Period, visit <a href="https://gamechanging.cadbury.co.uk" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.co.uk</a>, and select your region. Complete the online form providing the bar code and batch code along with your details (full name, email address and telephone number) to enter.</p></li>
                      <li><p><strong>ROI:</strong> Visit <a href="https://gamechanging.cadbury.ie" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.ie</a> within the Wrap-Up Draw Promotional Period and select ROI region. Complete the online form with your details (full name, email address, telephone number, full address including eircode) to enter. </p></li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li>
                <p><strong>Participating Players:</strong></p>
                <ol type="a">
                  <li><p>Leah Williamson</p></li>
                  <li><p>Jill Scott</p></li>
                  <li><p>Lauren James</p></li>
                  <li><p>Katie McCabe</p></li>
                </ol>
              </li>

              <li id="clause-6">
                <p><strong>Promotional Products:</strong></p>
                <ol type="a">
                  <li><p>Please see <button type='button' className='button button--text-link' onClick={() => scrollToSection("#products-list")}>Appendix 1</button> for the full list of Promotional Products.</p></li>
                </ol>
              </li>

              <li>
                <p>Maximum of 1 entry is permitted per person per day during the Promotion Period. Maximum of 10 entries per person during the entire Promotion Period. For entrants in the UK, an itemised receipt per entry may be required and must state the time and date of purchase, which must pre-date the entry date and time, and be between 10 March 2025 and the end of the Promotion Period. No household may win more than 1 x Level 1 Prize, 1 x Level 2 Prize and 1 x Level 3 Prize. </p>
              </li>

              <li>
                <p>A person is defined by name and email address and the combination needs to be unique to a single participant for a prize claim to be valid. Postal addresses used to claim may be checked and verified via Royal Mail PAF for eligibility. Winners are provisional at point of win/claim and may be subject to prize claim verification to qualify win.</p>
              </li>

              <li>
                <p>Entrants are advised to take care when entering their details as they cannot be changed once the entry is made. The Promoter is not responsible for typographical errors.</p>
              </li>

              <li>
                <p><strong>Winner Selection:</strong></p>
                <ol type="a">
                  <li><p><strong>Level 1 Prize Draw:</strong> 1 Winner per Participating Player Draw, 4 in total, will be randomly selected from all valid entries received for each Participating Player during the Promotion Period. For your total confidence, the Prize draws will be conducted by PromoVeritas, the independent promotional verification service, within 5 working days of the end of the Prize Draw and Winning Moments Promotion Period.</p></li>
                  <li>
                    <p><strong>Level 2 Winning Moments:</strong> During the Promotion Period, 250 “winning moments” (days, hours, minutes, seconds), have been randomly selected by an independent verification service. The first valid entry on or after that winning moment will be awarded the Prize. If no entry is received between one winning moment to the next, the winning moment will not be rolled over.  All 250 Prizes are available to be won.</p>
                  </li>
                  <li>
                    <p><strong>Level 3 Winning Moments:</strong> During the Promotion Period, 201 “winning moments” (days, hours, minutes, seconds), have been randomly selected by an independent verification service. The first valid entry on or after that winning moment will be awarded the Prize. If no entry is received between one winning moment to the next, the winning moment will not be rolled over.  All 201 Prizes are available to be won.</p>
                  </li>
                  <li>
                    <p><strong>Wrap Up Draw:</strong>1 provisional winner will be randomly selected from all valid entries received during the Wrap Up Draw Period. For your total confidence, the Prize Draw will be conducted by PromoVeritas, the independent promotional verification service, within 5 working days of the end of the Wrap Up Draw Period.</p>
                  </li>
                </ol>
              </li>

              <li id="clause-10">
                <p><strong>The Prizes:</strong></p>
                <ol type="a">
                  <li><p><strong>Level 1 Prize Draw:</strong> There will be 4 winners, 1 for each Participating Player. Each winner will win 1 x Meet and Greet Experience with the player they selected upon entry, for themselves and up to 3 guests for up to 60 minutes. The Meet and Greet Experience will include the following:</p></li>
                  <ol type="i">
                    <li><p>1 x night accommodation (minimum 4*) inclusive of breakfast (accommodation available on the night of OR night before the experience).</p></li>
                    <li><p>Return standard travel for 1 x Winner & 3 x Guests from their home to the experience. </p></li>
                    <li><p>A meet and greet with the Participating Player selected by the winner on entry</p></li>
                    <li><p>1 x signed shirt ((Winner has no choice of the size of the shirt, nor who they have been signed by).</p></li>
                    <li><p>Cadbury Hamper for Winner Only (valued at min. £35).</p></li>
                  </ol>
                  <p><strong>Prize fulfilment subject to Covid19 rules and regulations / club restrictions and terms and conditions around access and dates.</strong></p>
                  <p><strong>Any additional prize(s) are at the discretion of the Participating Player's and may vary between each Participating Player.</strong></p>
                  <br></br>
                  <li>
                    <p><strong>Level 2 Instant Win:</strong> 250 x pairs of matchday tickets for the 2025/26 football season for Participating Clubs, subject to availability.</p>
                  </li>
                  <li>
                    <p><strong>Level 3 Instant Win:</strong> There are 201 Prizes available to be won. Prizes will be randomly allocated.</p>
                    <ol type="i">
                      <li><p>51 x £/€100 Lifestyle vouchers (UK) or AllGifts.IE gift cards (ROI).</p></li>
                      <li><p>150 x £/€50 Lifestyle vouchers (UK) or AllGifts.IE gift cards (ROI).</p></li>
                    </ol>
                  </li>
                  <li>
                    <p><strong>Wrap Up Draw:</strong></p>
                    <ol type="i">
                      <li><p>1 x £/€250 Lifestyle vouchers (UK) or AllGifts.IE gift cards (ROI).</p></li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li id="clause-11">
                <p><strong>Further Entry and Prize Details and Conditions:</strong></p>
                <ol type="a">
                  <li><p>The Promoter may request that all winners participate in reasonable promotional activity (such as publicity and photography) surrounding the winning of the prize, free of charge, and they consent to the Promoter using their name and images in promotional material. The winners are under no obligation to participate and may decline this request. Participation is at the winner's discretion and is not a condition of prize acceptance.</p></li>
                  <li><p>By entering this promotion, the winner grants the Promoter the absolute and irrevocable right and permission to use, publish, publicly display, perform, transmit, exhibit and reproduce their name, statements, video, voice, recordings, interviews, photographs or other visual or audible representations or likeness, in whole or in part, individually or in conjunction with other material, including without limitation, text, photographs or images in any medium (whether now known or hereafter invented) including, but not limited to the internet and other electronic and social media and for any and all purposes, publicity, promotion, packaging and trade throughout the world without restriction as to manner, frequency or duration of use or any other purpose whatsoever in connection with this promotion or in connection with the marketing of the products of the Promoter, or otherwise. The winner further agrees that all materials produced pursuant to the rights set out above shall and will remain the property of the Promoter.</p></li>
                  <li><p>Any guests under the age of 18 must be accompanied by a parent or legal guardian.</p></li>
                  <li>
                    <p><strong>Level 1 Prizes:</strong></p>
                    <ol type="i">
                      <li><p>A guest cannot be a Winner of another Level 1 Prize Draw Prize.</p></li>
                      <li><p>The Prize will not take place at a player's home.</p></li>
                      <li><p>The player experiences must be taken before 31 December 2025. The experiences are subject to the chosen Participating Players' availability. The Promoter will endeavour to provide as much visibility as possible for the Prize date, although timings and location may only be confirmed (and are liable to move) days in advance, subject to the Participating Players' availability. Neither the Promoter nor the Participating Player will be liable in any way for any cancellation or postponement of the Prize.</p></li>
                      <li><p>Across all Participating Players involved in the promotion the Prize will take place on a date pre-determined by the Participating Player / Promoter (with winners unable to change) in 2025. Winners may need to attend at short notice anytime from August 2025 onwards.</p></li>
                      <li><p>In order to facilitate the smooth-running of the Prize, there will be a minimum of  2 representatives of the Promoter and the Participating Player during the Experience. If in the opinion of the Promoter, the winner or their guests behave and/or speak in an inappropriate manner or ask questions that have not been pre-approved, the representatives of the Promoter or Participating Player will issue an initial warning. If the behaviour and/or speech continues, the representatives of the Promoter or Participating Player will terminate the meet & greet and no alternative Prize, or any other form of compensation will be provided. The decision of the Promoter is final, and no correspondence will be entered into.</p></li>
                      <li><p>The prize will include standard class travel to and from the experience venue a minimum 4* hotel stay for 1 night (in 2x twin or 2x double rooms) for winner and 3 guests as well as food and drink at the experience.</p></li>
                      <li><p>Travel and accommodation will be arranged by the promoter’s agency and will be at their sole discretion.</p></li>
                      <li><p>For the avoidance of doubt, the Prize does not include travel/transportation, accommodation, food, beverages, souvenirs, gratuities, car parking charges, excess baggage, additional excursions and attractions or any other costs of a personal nature (including spending money) that are not explicitly set out in these Terms and Conditions and neither the Promoter nor any provider of any part of the Prize will be responsible for any such costs. For the avoidance of doubt, dinner at the hotel will not be included. </p></li>
                      <li><p>A valid credit or debit card may be required for the winner to check in to their room and will be used to guarantee any incidentals such as in- room calls or services.</p></li>
                      <li><p>The winner is solely responsible for any additional charges incurred during their stay, including, without limitation, costs of meals, drinks, additional nights and services together with related taxes.</p></li>
                      <li><p>The Winner will be subject to a name check against any professional association football club venue or sporting Banning Orders as well as the National Police Database for those who may be subject to a court banning order.</p></li>
                      <li><p>If any of the guests are under the age of 18, then they should be accompanied by a responsible adult and with their guardian's consent.</p></li>
                      <li><p>Except mobile phones used for personal and private use only, you may not bring into (or use within) the venue where the Meet and Greet Experience will take place, any equipment that is capable of recording or transmitting any audio, visual or audio-visual material or any information or data in relation to a match or any aspect of it.</p></li>
                      <li><p>Redemption of all Prizes is subject to Government guidelines and lockdown measures which can be found at: <a href="https://gov.uk/coronavirus" target="_blank" rel="noopener noreferrer">https://www.gov.uk/coronavirus</a> </p></li>
                      <li><p>If Government guidelines restrict redemption of the Prize in its current form, the Promoter will work with the winner to discuss moving the Prize to a later date or issuing an alternative Prize.</p></li>
                      <li><p>At all times, the Promoter will have the discretion as to how to implement the Prize fulfilment.  </p></li>
                      <li><p>Once dates, tickets, or names are booked, they cannot be altered or changed except at the Promoter’s sole discretion. </p></li>
                      <li><p>The dates available for the experiences are not guaranteed and are subject to C19 / club restrictions around access and dates.</p></li>
                      <li><p>The Prize will be arranged by email/phone between the Promoter’s agency and the individual winners. The Promoter’s agency will make all reasonable efforts to provide the winner with details of the Prize at the earliest possible opportunity. The Promoter will have final discretion on all elements and aspects of how the Prize is organised. Once the Prize details, including dates and locations are confirmed, this cannot be amended or altered by the winner.</p></li>
                      <li><p>The Winner is responsible for the behaviour of themselves and their guests whilst taking the Prize. The Promoter reserves the right in its absolute discretion to exclude a winner and/or their guests from participation in any aspect of the Prize if any party fails to comply with the directions of the Promoter or any companies associated with the Prize or if a winner and/or their guests act in a manner that is dangerous to themselves or to the public or is, in the opinion of the Promoter, anti-social in any manner or which causes a disturbance or nuisance to others. Failure to comply with these Terms and Conditions may result in refused entry, or the ticket holders being required to leave the event/venue.</p></li>
                      <li><p>Winners must inform the Promoter of any wheelchair or any similar access needs.</p></li>
                    </ol>
                  </li>
                  <li>
                    <p><strong>Level 2 Prizes:</strong></p>
                    <ol type="i" start="22">
                      <li><p>Participating Clubs defined as: Arsenal FC Women, Chelsea FC Women, Crystal Palace FC Women, Liverpool FC, and Manchester United FC Women.</p></li>
                      <li><p>Matchday tickets will be made available once the 2025/2026 fixture list has been confirmed.</p></li>
                      <li><p>Manchester United FC Women’s tickets may be for any Women’s team home fixtures, including those at Leigh Sports Village and Old Trafford.</p></li>
                      <li><p>The winner will receive their tickets via email.</p></li>
                      <li><p>One of either the Winner or the guest must be 18+ to enter the Participating Club’s stadium. Children can be taken with an adult. </p></li>
                      <li><p>Exact match dates may be subject to change by the Participating Club and/or football league. If there is a change in date, the Promoter will communicate this to the winners/entrants and the Promoter is not liable for any date changes. Winners/entrants will not be able to exchange or transfer tickets. </p></li>
                      <li><p>Winners will be subject to a name check against any professional association football club, venue or sporting Banning Orders as well as the National Police Database for those who may be subject to a court banning order. </p></li>
                      <li><p>All Prizes are only available to home or neutral supporters of the Participating Clubs, so all necessary checks/ conditions must be adhered to. The Promoter reserves the right to disqualify any potential winner and/or guest on the basis of the findings resulting from a background or information check and award the tickets to an alternative winner.   </p></li>
                      <li><p>Entry to any stadium is subject to the normal terms and conditions of entry of the applicable stadium and/or Participating Club. All tickets will be “home” tickets. Away fans are not permitted in the “home” section of a stadium. Winners are subject to screening by Participating Clubs  based on their conditions of entry and we are not liable if you or any person accompanying you is refused entry because you do not meet these conditions.</p></li>
                      <li><p>Attending fans are required to not wear opposition colours and doing so may result in entry to the stadium not being permitted.</p></li>
                      <li><p>Each ticket is issued by the relevant Participating Club subject to the terms and conditions of entry, which are available from the Participating Club and will be provided to you with your Prize. The use of a ticket to enter a Participating Club’s stadium constitutes acceptance of that Participating Club's terms and conditions of entry. The ticket shall remain at all times the property of the issuing Participating Club.</p></li>
                      <li><p>For the avoidance of doubt, the Prize does not include, travel, accommodation, souvenirs, gratuities, car parking charges, excess baggage, additional excursions and attractions or any other costs of a personal nature (including spending money), or any costs incurred due to Covid-19, that are not explicitly set out in these Terms and Conditions and neither the Promoter nor any provider of any part of the Prize will be responsible for any such costs. For the avoidance of doubt, dinner at the hotel will not be included. </p></li>
                      <li><p>The venue reserves the right to refuse entry to any person who does not adhere to their terms, checks and requirements, regardless of possession of a valid ticket.</p></li>
                      <li><p>The winner is responsible for the behaviour of themselves and their guests whilst taking the Prize. The Promoter reserves the right in its absolute discretion to exclude the winner and/or their guests from participation in any aspect of the Prize if any party fails to comply with the directions of the Promoter or any companies associated with the Prize or if the winner and/or their guests act in a manner that is dangerous to themselves or to the public or is, in the opinion of the Promoter, anti-social in any manner or which causes a disturbance or nuisance to others. Failure to comply with these Terms and Conditions may result in refused entry, or the ticket holders being required to leave the event/venue. The Promoter reserves the right to disqualify any entry from a person who is the subject of a stadium banning order or is otherwise prohibited from attending football matches by any professional association football club or any competent authority.</p></li>
                      <li><p>If for any reason the event is not capable of running as planned, such as cancellation or any other cause beyond the control of the Promoter which affects the running or conduct of this promotion, the Promoter may in its sole discretion cancel the Prize and not re-award any additional tickets to the winner or reimburse any incurred expenses by the winner as a result of winning or accepting the Prize.</p></li>
                      <li><p>Once tickets have been issued, the Promoter, will not be liable for any failure to comply with its obligations caused by (but not limited to) weather conditions, fire, flood, strike, hurricane, industrial dispute, war, terrorist activity, hostilities, political unrest, riots, civil commotion, illness of a performer or any other circumstances beyond the control of the Promoter.</p></li>
                      <li><p>Winners must inform the Promoter of any wheelchair or any similar access needs.</p></li>
                    </ol>
                  </li>

                  <li>
                    <p><strong>Level 3 Prizes: </strong></p>
                    <ol type="i" start="38">
                      <li><p>Lifestyle voucher terms and conditions can be found <a href="https://lifestylegiftcards.co.uk/terms" target="_blank" rel="noopener noreferrer">here</a>. The voucher will expire 18 months from date of Prize Acceptance.</p></li>
                      <li><p>AllGifts.IE terms and conditions can be found <a href="https://allgifts.ie/terms_and_conditions.aspx" target="_blank" rel="noopener noreferrer">here</a>. The voucher will expire 5 years from date of Prize Acceptance.</p></li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li id="clause-11">
                <p><strong>Winner Notification:</strong></p>
                <ol type="a">
                  <li><p><strong>Level 1 Prize Draw:</strong> Provisional winners will be contacted via the email address provided on entry within 5 working days of Winner Selection and will be asked to provide evidence of identity and eligibility. Reasonable efforts will be made to contact the winners. If a winner does not respond to the initial contact and provide valid evidence of their identification for verification within 5 days, we reserve the right to disqualify that entrant and award the Prize to a reserve selected in the same manner. Reserve winners may have less time to respond.</p></li>
                  <li><p><strong>Level 2 & 3 Instant Win:</strong> The provisional winning entrants will be instantly notified on screen that they are a winner. Winners will also receive a confirmation email to their email address used upon entry, confirming their Prize and will be required to follow the instructions within 14 days  of initial contact. If a provisional winner does not follow the instructions in the confirmation email within 14 days of initial contact, the Promoter reserves the right to disqualify those provisional winners.
                    Any claims received that don’t meet these requirements will be void and invalid and the Prize will not be returned to the Promotion Prize pool.
                  </p></li>
                  <li><p><strong>Wrap Up Draw:</strong> The provisional winner will be contacted via the email address provided on entry within 5 days of Wrap Up Draw Winner Selection and will be asked to provide evidence of identity and eligibility. Reasonable efforts will be made to contact the winner. If the winner does not respond to the initial contact within 14 days, the Promoter reserve the right to disqualify that entrant and award the Prize to a reserve selected in the same manner. Reserve winners may have less time to respond.</p></li>
                </ol>
              </li>

              <li>
                <p><strong>Prize Acceptance: :</strong></p>
                <ol type="a">
                  <li><p><strong>Level 1 & Wrap-Up Prize Draw:</strong> Once eligibility of a Prize is confirmed and the Prize is accepted, winners will be notified within 28 days of acceptance of the Prize to arrange fulfilment of the Prize. In the unlikely event that a winner does not receive their notification within 28 days, the winners will have a further 28 days to inform the Promoter by emailing <a href="mailto:cadburygamechangers@promowinners.com" target="_target" rel="noopener noreferrer">cadburygamechangers@promowinners.com</a>. If a winner does not do so, the Promoter reserves the right to not reissue the Prize or limit its value at its sole discretion.</p></li>
                  <li><p><strong>Level 2 Instant Win:</strong> Once eligibility of a Prize is confirmed and the Prize is accepted, winners will be notified within 28 days of acceptance of the Prize to arrange fulfilment of the Prize. In the unlikely event that a winner does not receive their notification within 28 days, the winners will have a further 28 days to inform the Promoter by <a href="mailto:cadburygamechangers@promowinners.com" target="_target" rel="noopener noreferrer">cadburygamechangers@promowinners.com</a>. If a winner does not do so, the Promoter reserves the right to not reissue the Prize or limit its value at its sole discretion.</p></li>
                  <li><p><strong>Level 3 Instant Win:</strong> Once eligibility of a Prize is confirmed and the Prize is accepted, winners will be notified within 28 days of acceptance of the Prize to arrange fulfilment of the Prize. In the unlikely event that a winner does not receive their notification within 28 days, the winners will have a further 28 days to inform the Promoter by emailing <a href="mailto:cadburygamechangers@promowinners.com" target="_target" rel="noopener noreferrer">cadburygamechangers@promowinners.com</a>. If a winner does not do so, the Promoter reserves the right to not reissue the Prize or limit its value at its sole discretion.</p></li>
                </ol>
              </li>

              <li ref={clause13}>
                <p>Provided no objection is received, the surname and county of the Level 1 Prize winners will be made available to anyone who requests them by writing to <strong>JS15028 Cadbury FC Game Changer, PO Box 704, Pinner, HA5 9PF</strong>, within 3 months of the closing date. In the event they win, winners may request their surname and county are not published or request for the amount of information being published to be reduced during Winner Notification process. Without prejudice, the Promoter will provide this information to the Advertising Standards Authority on reasonable request.</p>
              </li>

              <li>
                <p>The Promoter may request that the winners participate in reasonable publicity arising from the Promotion. Participation is at the winner’s discretion and is not a condition of Prize Acceptance.</p>
              </li>

              <li>
                <p>The Promoter seeks to run a fair and secure promotion and prevent abuse and cheating. If you enter in a way that is not consistent with these Terms & Conditions, your entries (and any of your associated aliases) will be disqualified. Any Prize awarded may be void and recoverable, and the Promoter reserves the right to bar you from entering future promotions for a period of at least six months. For this reason, the Promoter reserves the right at any point to:</p>
                <br></br>
                <ol type="a">
                  <li><p>Verify the eligibility of entrants and/or provisional winners by requesting such information it consider reasonably necessary for this purpose. Entry or a Prize may be withheld until verification is completed.</p></li>
                  <li><p>Disqualify entries that are not made directly by the individual entering the Promotion</p></li>
                  <li><p>Disqualify entries made using anonymous email services such as, but not limited to, GuerillaMail, Dispostable or Mailinator.</p></li>
                  <li><p>Disqualify bulk entries from individuals, trade, consumer groups or third parties, incomplete entries and entries submitted by macros or other automated means.</p></li>
                  <li><p>Disqualify entries beyond the maximum allowed, or those using techniques such as ‘script’, ‘brute force’, multiple SIM cards for text entries, masking identity by manipulating IP addresses, using aliases or identities other than their own or any other means.</p></li>
                  <li><p>Disqualify entrants who tamper with the entry process</p></li>
                  <li><p>Disqualify entries which, in some other way, do not meet the requirements of these Terms & Conditions. </p></li>
                  <li><p>Cancel, modify or suspend the Promotion should it not be capable of running as planned for reasons including but not limited to tampering, unauthorised intervention, fraud, dishonesty, technical failures, or any other causes beyond the control of the Promoter which corrupt or affect the administration, security, fairness, integrity or proper conduct of this Promotion.</p></li>
                </ol>
              </li>

              <li>
                <p>The Prizes are not transferable or exchangeable and cannot be redeemed for monetary value or for any other form of compensation. If for any reason a Prize or any element of a Prize is not available, the Promoter reserves the right, at its sole discretion to substitute that Prize or element of a Prize for another of equal or greater value.</p>
              </li>

              <li>
                <p>No responsibility can be taken for entries which are lost, delayed, corrupted, damaged, misdirected or incomplete or which cannot be delivered for any technical, delivery or other reason. Proof of sending will not be accepted as proof of receipt. The Promoter does not guarantee continuous or secure access to <a href="https://gamechanging.cadbury.co.uk" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.co.uk</a> or <a href="https://gamechanging.cadbury.ie" target="_blank" rel="noopener noreferrer">gamechanging.cadbury.ie</a>.</p>
              </li>

              <li>
                <p>The Promoter and its associated agencies and companies are not liable for any loss (including, without limitation, indirect, special or consequential loss or loss of profits), expense or damage which is suffered or sustained (whether or not arising from any person’s negligence) in connection with this Promotion or accepting or using the/a Prize(s), except for any liability which cannot be excluded by law.  Nothing will exclude the Promotor’s liability for death or personal injury as a result of its negligence.</p>
              </li>

              <li>
                <p>The Promoter will not be liable for any delay or failure to comply with its obligations for reasons beyond its reasonable control arising from but not limited to Acts of God, global or regional epidemic or pandemic, adverse weather conditions, fire, industrial dispute, war, terrorist activity, hostilities, political unrest, riots, civil commotion, plague or other natural calamities, or any other circumstances.</p>
              </li>

              <li>
                <p>This Promotion is administered and run by the Promoter and is not in any way administered by Arsenal Women FC (or any of its affiliated entities),  Chelsea Women FC, Crystal Palace FC, Liverpool FC or Manchester United FC. By entering this Promotion you acknowledge that Arsenal Women FC, Chelsea Women FC, Crystal Palace FC, Liverpool FC or Manchester United FC, shall not have any liability to you in connection with the promotion. The Promotion is not in any way sponsored, endorsed or administered by, or associated with Leah Williamson, Jill Scott, Lauren James or Katie McCabe. By entering the Promotion, you acknowledge that Leah Williamson, Jill Scott, Lauren James or Katie McCabe shall not have any liability to you in connection with this Promotion.</p>
              </li>

              <li>
                <p>The Promoter shall comply with all applicable requirements of the Data Protection Act 2018, the General Data Protection Regulation 2016 and any successor legislation or other applicable law. The personal information entrants provide will be used by the Promoter for the purpose of conducting this promotion and in accordance with the Promoters’ Data Privacy Notice which can be found at <a href="https://www.cadbury.co.uk/privacy" target="_blank" rel="noopener noreferrer">www.cadbury.co.uk/privacy</a>. The Promoter may disclose entrants’ personal information to its contractors and agents to assist in conducting this Promotion (including any relevant promotional activity) or communicating with entrants.</p>
              </li>

              <li>
                <p>If any part of these Terms & Conditions are legally ruled to be invalid, illegal or unenforceable, the remainder will not be affected and will continue in full force and effect.</p>
              </li>

              <li>
                <p>By entering, you will be deemed to have agreed to be bound by these Terms & Conditions.</p>
              </li>

              <li>
                <p>If there is a discrepancy between these Terms & Conditions and those in any promotional material, these Terms & Conditions will prevail. </p>
              </li>
              <li>
                <p>These Terms & Conditions are governed by English law and their interpretation and application will be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
              </li>
            </ol>
            <p><strong>Promoter:</strong></p>
            <p>UK: Mondelez Europe Services GmbH - UK Branch whose address is at Cadbury House, Sanderson Road, Uxbridge, UB8 1DH.</p>
            <p>ROI: Mondelez Europe Services GmbH - Ireland Branch whose address is at Malahide Road, Coolock, Dublin 5 </p>
            <p>(together the "Promoter").</p>
          </div>
        </div>

        <div className='policies'>
          <div id="products-list" ref={appendix} className="type-h3 type-h3--gold">Appendix 1:</div>

          <ul className='reduced-list'>
            <li>	Cadbury Bournville 100G price marked pack 169P 18CA	</li>
            <li>	Cadbury 95G price marked pack 169P 22CA	</li>
            <li>	Cadbury 95G price marked pack 169P 22CA	</li>
            <li>	Cadbury 95G price marked pack Fruit & Nut 169P 22CA	</li>
            <li>	Cadbury 96G price marked pack OREO 169P 15CA	</li>
            <li>	Cadbury 120G price marked pack CARAMEL 169P 16CA	</li>
            <li>	Cadbury 120G OREO WHITE 169P 17CA	</li>
            <li>	Cadbury 120G price marked pack DAIM 169P 18CA	</li>
            <li>	Cadbury 120G price marked pack OREO 169P 17CA	</li>
            <li>	Cadbury 90G WHITE price marked pack 169P 24CA	</li>
            <li>	Cadbury 80G price marked pack 169P 26CA	</li>
            <li>	Cadbury 95G TOP DECK 169P price marked pack 23CA	</li>
            <li>	Cadbury 95G 169P 22CA 25	</li>
            <li>	Cadbury 95G 22CA	</li>
            <li>	Cadbury 95G CHOPPED NUT 22CA	</li>
            <li>	Cadbury 95G DAIRY MILK 22CA	</li>
            <li>	Cadbury WHITE 90G 24CA	</li>
            <li>	Cadbury 80G CARAMELILK 26CA	</li>
            <li>	Cadbury 100g BOURNVILLE 18CA	</li>
            <li>	Cadbury 100G BOURV ORNG 18CA	</li>
            <li>	Cadbury 100G BOURVILLE OLD JAMAICA 18CA             	</li>
            <li>	Cadbury 100G BOURVILLE MINT 16CA	</li>
            <li>	Cadbury 90G DARK MILK 16CA	</li>
            <li>	Cadbury 96G OREO SANDWICH 15CA	</li>
            <li>	Cadbury 120G SALTED CARAMEL 16CA	</li>
            <li>	Cadbury 120G OREO WHITE 17CA     	</li>
            <li>	Cadbury 110G DAIRY MILK 21CA	</li>
            <li>	Cadbury Fruit & Nut 110G 18CA	</li>
            <li>	Cadbury 120G CARAMEL 16CA	</li>
            <li>	Cadbury 110G TOP DECK 20CA	</li>
            <li>	Cadbury 95G TOP DECK 23CA	</li>
            <li>	Cadbury 120G DAIM 18CA	</li>
            <li>	Cadbury 120G OREO 17CA	</li>
            <li>	Cadbury 120G WHOLENUT 16CA	</li>
            <li>	Cadbury 90G CARAMEL 24CA	</li>
            <li>	Cadbury 85G CARAMILK CRISP 24CA	</li>
            <li>	Cadbury PLANT BAR 90G 18CA	</li>
            <li>	Cadbury 110G Cadbury EXPORT 21CA	</li>
            <li>	Cadbury 180G BOURNVILLE 18CA	</li>
            <li>	Cadbury WHITE CHOCOLATE 180G 15CA	</li>
            <li>	Cadbury 160G CARAMEL 19CA	</li>
            <li>	Cadbury 180G 17CA	</li>
            <li>	Cadbury 180G WHOLENUT 14CA	</li>
            <li>	Cadbury 180G Fruit & Nut 15 CA	</li>
            <li>	Cadbury CRUNCHIE 180G 16CA	</li>
            <li>	Cadbury 180G CARAMEL 17CA	</li>
            <li>	Cadbury 160G JELLY POPPING CANDY 19CA	</li>
            <li>	Cadbury 180G CARAMEL PROMO PACK GAME CHANGING WINS 17CA	</li>
            <li>	Cadbury 180G WHOLENUT PROMO PACK GAME CHANGING WINS 14CA	</li>
            <li>	Cadbury 180G FRUIT & NUT PROMO PACK GAME CHANGING WINS 15CA	</li>
            <li>	Cadbury 180G 17CA PCK 2025	</li>
            <li>	Cadbury 300G 13CA	</li>
            <li>	Cadbury 300G FRUIT AND NUT 12CA	</li>
            <li>	Cadbury 280G WHOLENUT 12CA	</li>
            <li>	Cadbury 300G OREO 13CA	</li>
            <li>	Cadbury 280g 13CA	</li>
            <li>	Cadbury 280g Fruit & Nut 12CA	</li>
            <li>	Green & Blacks 90G DARK CHOC 70% 15CA	</li>
            <li>	Green & Blacks 90G MILK CHOC 15CA	</li>
            <li>	Green & Blacks 90G HAZEL NUT CURRANT 15CA	</li>
            <li>	Green & Blacks 90G BUTTERSCOTCH 15CA	</li>
            <li>	Green & Blacks 90G GINGER CHOC 15CA	</li>
            <li>	Green & Blacks 90G DARK CHOC 85% 15CA	</li>
            <li>	Green & Blacks 90G WHITE CHOC 15CA	</li>
            <li>	G&B 90G ORG SMOOTH DARK 15CA	</li>
            <li>	G&B 90G ORG SMOOTH MINT 15CA	</li>
            <li>	Green & Blacks 90G ORG SMTH 50FT15CA	</li>
            <li>	Green & Blacks 90G ORG SM MNT FT15CA	</li>
            <li>	Green & Blacks 150G DARK COOKING CHOCOLATE 15CA	</li>
            <li>	BUBBLY MILK AND WHITE 95G 15CA	</li>
            <li>	MILKA 100G WTH OREO COOKIES 22CA	</li>
            <li>	MILKA 100G DAIM PIECES 22CA	</li>
            <li>	MILKA 100G NOISETTE 23CA	</li>
            <li>	MILKA 100G 23CA CL5	</li>
            <li>	MILKA 100G ALPINE MILK 24CA CL5	</li>
            <li>	MILKA 90G NOISETTE 25CA	</li>
            <li>	MILKA 90G 24CA CL5	</li>
            <li>	MILKA 90G TBL ALPINE MILK 25CA CL5	</li>
            <li>	MILKA 270G MILK 16CA	</li>
            <li>	MILKA 270G MILK WHOLE NUTS 13CA	</li>
            <li>	MILKA 300G OREO 12CA	</li>
            <li>	MILKA 250G MILK 17CA	</li>
            <li>	MILKA 250G MILK WHOLE NUTS 14CA	</li>
            <li>	Cadbury TWIRL SGL 48X43G	</li>
            <li>	Cadbury 36G WISPA SGL 48CA	</li>
            <li>	Cadbury BOOST 48.5G 48CA	</li>
            <li>	Cadbury CRUNCHIE SGL 48	</li>
            <li>	Cadbury 54.5G DOUBLE DECKER 48CA	</li>
            <li>	Cadbury 48G WISPA GOLD 48CA	</li>
            <li>	TWIRL ORANGE 48CA	</li>
            <li>	Cadbury 43G TWIRL WHITE 48CA	</li>
            <li>	Cadbury 43G TWIRL price marked pack 75P 48CA	</li>
            <li>	TWIRL 75P price marked pack 48CA	</li>
            <li>	Cadbury 36G WISPA price marked pack 75P 48CA	</li>
            <li>	Cadbury 48.5G BOOST price marked pack 75P 48CA	</li>
            <li>	Cadbury 40G CRUNCH 75P 48CA	</li>
            <li>	Cadbury 54.5G DOUBLE DECKER price marked pack 75P 48CA	</li>
            <li>	Cadbury 48G WISPA GOLD 75P 48CA	</li>
            <li>	Cadbury 49G STARBAR price marked pack 75P 32CA	</li>
            <li>	Cadbury 45G price marked pack 75P 48CA	</li>
            <li>	Cadbury JELLY POPPING CANDY 47G price marked pack 75P 24CA	</li>
            <li>	Cadbury 48.4G PICNIC 75P 36CA	</li>
            <li>	Cadbury 45G CARAMEL 75P 48CA	</li>
            <li>	Cadbury 43G TWIRL price marked pack 89P 48CA	</li>
            <li>	TWRL 89P price marked pack 48CA	</li>
            <li>	Cadbury 36G WISPA price marked pack 89P 48CA	</li>
            <li>	Cadbury 48.5G BOOST price marked pack 89P 48CA	</li>
            <li>	Cadbury 40G CRUNCHIE 89P 48CA	</li>
            <li>	Cadbury 54.5G DOUBLE DECKER price marked pack 89P 48CA	</li>
            <li>	Cadbury 48G WISPA GOLD 89P 48CA	</li>
            <li>	Cadbury 49G STARBAR price marked pack 89P 32CA	</li>
            <li>	Cadbury 45G price marked pack 89P 48CA	</li>
            <li>	Cadbury MC JELLY POPPING CANDY 47G price marked pack 89P 24CA	</li>
            <li>	Cadbury 48.4G PICNIC 89P 36CA	</li>
            <li>	Cadbury 45G CARAMEL 89P 48CA	</li>
            <li>	Cadbury 45G WHOLENUT 48CA	</li>
            <li>	Cadbury 45G CARAMEL 48CA	</li>
            <li>	Cadbury STD 48CA	</li>
            <li>	Cadbury 49G FRUIT NUT 48CA	</li>
            <li>	Cadbury 47G POPPING CANDY	</li>
            <li>	Cadbury GT BUTTONS FT 36X40G	</li>
            <li>	Cadbury 49G STARBAR 32CA	</li>
            <li>	Cadbury 48G PICNIC 36CA	</li>
            <li>	Cadbury SGL FLAKE 48CA	</li>
            <li>	FRYS 51G SINGLE 48CA	</li>
            <li>	FRYS 49G CHOCOLATE CREME 48CA	</li>
            <li>	FRYS 49G PEPPERMINT CREME 48CA	</li>
            <li>	Cadbury 37G CARAMILK 36CA	</li>
            <li>	DAIM SINGLE 36X28G	</li>
            <li>	Cadbury 40G FNUTIER ORIGINAL BAR 24CA	</li>
            <li>	Cadbury 2X27G TWIRL XTRA 36CA	</li>
            <li>	Cadbury 63G BOOST DUO 32CA	</li>
            <li>	Cadbury 74.6G DUO DOUBLE DECKER 32CA	</li>
            <li>	DAIRY MILK 54.4G DUO 36CA	</li>
            <li>	Cadbury 47.4G DUO WISPA 32CA	</li>
            <li>	Cadbury STARBAR DUO 74G 32CA	</li>
            <li>	Cadbury STD FREDDO 60CA	</li>
            <li>	Cadbury 19.5G FREDDO CARAMEL 60 CA	</li>
            <li>	Cadbury 18G LITTLE BAR 60CA	</li>
            <li>	Cadbury SGL FUDGE 22G 60CA	</li>
            <li>	Cadbury 21.8g Curly Wurly 48CA	</li>
            <li>	Cadbury 18G FREDDO STD 30P 60CA	</li>
            <li>	Cadbury 19.5G FREDDO CARAMELEL 30P 60CA	</li>
            <li>	Cadbury 21G CHOMP 30P price marked pack 60CA	</li>
            <li>	Cadbury SGL FUDGE 22G 30P price marked pack 60CA	</li>
            <li>	Cadbury 18G FREDDO STD 35P 60CA	</li>
            <li>	Cadbury 19.5G FREDDO CARAMELEL 35P 60CA	</li>
            <li>	Cadbury 21G CHOMP 35P price marked pack 60CA	</li>
            <li>	Cadbury SGL FUDGE 22G 35P price marked pack 60CA	</li>
            <li>	Cadbury 8.3GRX144 FLAKE99 1CA	</li>
            <li>	Cadbury 8.3GRX14 FLAKE FAM 20CA	</li>
            <li>	Cadbury BIG WIN WIN 43G TWIRL 48CA	</li>
            <li>	Cadbury 43G TWIRL BIG WIN WIN price marked pack 89P 48CA	</li>
            <li>	Cadbury 36G WISPA BIG WIN WIN price marked pack 89P 48CA	</li>
            <li>	Cadbury 40G CRUNCH BIG WIN WIN 89P 48CA	</li>
            <li>	Cadbury 48.5G BOOST BIG WIN WIN price marked pack 89P 48CA	</li>
            <li>	Cadbury 48G WISPA GOLD BIG WIN WIN 89P 48CA	</li>
            <li>	Cadbury BIG WIN WIN 49G STARBAR 32CA	</li>
            <li>	Cadbury 49G STARBAR BIG WIN WIN price marked pack 89P 32CA	</li>
            <li>	Cadbury 45G BIG WIN WIN price marked pack 89P 48CA	</li>
            <li>	Cadbury BIG WIN WIN STD 48CA	</li>
            <li>	Cadbury BIG WIN WIN 2X27G TWIRL XTRA 36CA	</li>
            <li>	Cadbury BIG WIN WIN 63G BOOST DUO 32CA	</li>
            <li>	Cadbury BIG WIN WIN 74.6G DUO DOUBLE DECKER 32CA	</li>
            <li>	Cadbury BIG WIN WIN DAIRY MILK 54.4G DUO 36CA	</li>
            <li>	Cadbury BIG WIN WIN 47.4G DUO WISPA 32CA	</li>
            <li>	Cadbury BIG WIN WIN STARBAR DUO 74G 32CA	</li>
            <li>	FRYS 147G PEPPENRMIT CREAM 3PK 16CA	</li>
            <li>	FRYS 147G CHOCOLATE CREAM 3PK 16CA	</li>
            <li>	FRYS 147G ORANGE 3PK 16CA	</li>
            <li>	FRYS 153G TURKISH DELIGHT 3PK 24CA	</li>
            <li>	DAIM 3X28G 3PK 24CA	</li>
            <li>	Cadbury 80G 4PK FLAKE 20CA	</li>
            <li>	Cadbury 107.5G 5PK TWIRL 20CA	</li>
            <li>	Cadbury 104.4G 4PK CRUNCHIE 10CA	</li>
            <li>	Cadbury 128G 4PK PICNIC 10CA	</li>
            <li>	Cadbury 149.2G 4PK DOUBLE DECKER 8CA	</li>
            <li>	Cadbury 108.8G DAIRY MILK 4PK 14CA	</li>
            <li>	Cadbury 126G BOOST 4PK 12CA	</li>
            <li>	Cadbury 94.8G WISPA 4PK 11CA	</li>
            <li>	Cadbury 107.5G TWIRL 5PK price marked pack 189P 20CA	</li>
            <li>	Cadbury 126G BOOST price marked pack 189P 12CA	</li>
            <li>	Cadbury 94.8G WISPA price marked pack 189P 11CA	</li>
            <li>	Cadbury 104.4G CRUNCHIE 4PK 189P 10CA	</li>
            <li>	Cadbury 149.2G DOUBLE DECKER price marked pack 189P 8CA	</li>
            <li>	Cadbury 108.8G 4PK price marked pack 189P 14CA	</li>
            <li>	Cadbury 107.5G TWIRL 5PK price marked pack 20CA	</li>
            <li>	Cadbury BOOST 126G 165P 12CA	</li>
            <li>	Cadbury 94.8G WISPA 165P 11CA	</li>
            <li>	Cadbury 104.4G CRUNCHIE 4PK 165P 10CA	</li>
            <li>	Cadbury 149.2G DOUBLE DECKER 165P 8CA	</li>
            <li>	Cadbury 108.8G 4PK 165P 14CA	</li>
            <li>	Cadbury 102G 4PK FLAKE 20CA	</li>
            <li>	Cadbury 136G 4PK TWIRL 12CA.	</li>
            <li>	Cadbury 129G 3PK TWIRL 12CA	</li>
            <li>	Cadbury 129G 3PK TWIRL 12CA	</li>
            <li>	Cadbury 129G 3PK TWIRL ORANGE 12CA	</li>
            <li>	Cadbury CRUNCHIE 128G 4 PCK 10CA	</li>
            <li>	Cadbury 152G 4PK PICNIC 10CA	</li>
            <li>	Cadbury 148G CARAMEL 4PK 15CA	</li>
            <li>	Cadbury 174.8G 4PK DOUBLE DECKER 8CA	</li>
            <li>	Cadbury 148G BOOST 4PK 12CA	</li>
            <li>	Cadbury 134G 4PK 15CA	</li>
            <li>	Cadbury 111.6G WISPA 4PK 11CA	</li>
            <li>	Cadbury WISPA GOLD 153.2G 4PK 11CA	</li>
            <li>	Cadbury STARBAR 4X37G MP 12CA	</li>
            <li>	Cadbury CRUNCHIE 128G 4PK PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 148G CARAMEL PROMO PACK GAME CHANGING WINS 4PK 15CA	</li>
            <li>	Cadbury 111.6G WISPA 4PK PROMO PACK GAME CHANGING WINS 11CA	</li>
            <li>	Cadbury 134G 4PK PROMO PACK GAME CHANGING WINS 15CA	</li>
            <li>	Cadbury 128G 4PK 10CA	</li>
            <li>	Cadbury 129G 3PK 12CA	</li>
            <li>	Cadbury 134G 4PK 15CA	</li>
            <li>	Cadbury DELIGHTS SALTED CARAMEL 5PK 110G 9CA	</li>
            <li>	Cadbury DELIGHTS ORANGE 5PK 110G 9CA	</li>
            <li>	Cadbury NOUGAT HAZELNUT 5PK 110G 9CA	</li>
            <li>	Cadbury DELIGHTS SALTED CARAMEL 4PK 88G 9CA	</li>
            <li>	Cadbury DELIGHTS HAZELNUT 4PK 88G 9CA	</li>
            <li>	Cadbury 4X30G FRUITIER NUTTIER MPK 11CA	</li>
            <li>	Cadbury 4X30G FRUITIER NUTTIER ORIGINAL MPK 11CA	</li>
            <li>	TWIRL 215G 10PK 10CA	</li>
            <li>	DAIRY MILK 244.8G 9PK 14CA	</li>
            <li>	Cadbury 335.7G 9PK DOUBLE DECKER 8CA	</li>
            <li>	Cadbury 213.3G WISPA 9PK 11CA	</li>
            <li>	Cadbury 234.9G CRUNCHIE 9PK 10CA	</li>
            <li>	TWIRL 193.5G 9PK 10CA	</li>
            <li>	DAIRY MILK 190.4G 7PK 14CA	</li>
            <li>	Cadbury 261.1G 7PK DOUBLE DECKER 8CA	</li>
            <li>	Cadbury 165.9G WISPA 7PK 11CA	</li>
            <li>	Cadbury 90G 5PK FREDDO 30CA	</li>
            <li>	Cadbury 97.5G FREDDO CARA 5PK 30CA	</li>
            <li>	Cadbury 70G DAIRY MILK BUTTONS 5PK 16CA	</li>
            <li>	Cadbury 110G 5PK FUDGE 20CA	</li>
            <li>	Cadbury 107.5G 5PK CURLY WURLY 28CA	</li>
            <li>	Cadbury 108G LITTLE BARS 6PK 18CA	</li>
            <li>	Cadbury GIANT BUTTONS 184.8G 10CA	</li>
            <li>	Cadbury CARAMEL NIBBLES BITESIZE 186G 10CA	</li>
            <li>	Cadbury BITSA WISPA 185.5G 10CA	</li>
            <li>	Cadbury 192G Cadbury MEGA GT BUTTONS 10CA	</li>
            <li>	Cadbury 192G WHITE MEGA BUTTONS 10CA	</li>
            <li>	FRYS 225G TURK DEL MINI BAR 10CA	</li>
            <li>	DAIM 200G MINI 18CA	</li>
            <li>	Cadbury GIANT BUTTONS 184.8G 10CA	</li>
            <li>	Cadbury 119G GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 120G CARAMEL NIBBLES 10CA	</li>
            <li>	Cadbury 109G TWIRL BITES 10CA	</li>
            <li>	Cadbury 110G CRUNCHIE ROCKS 10CA	</li>
            <li>	Cadbury 110G BITSA WISPA BAG 10CA	</li>
            <li>	Cadbury 110G Cadbury ORANGE BUTTONS 10CA	</li>
            <li>	Cadbury 110g OREO BITES 10CA	</li>
            <li>	Cadbury 105G CARMILK BUTTONS 10CA            	</li>
            <li>	Cadbury 110G Cadbury MINT GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 110G WHITE GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 110G CURLY WURLY SQUIRLIES 10CA	</li>
            <li>	Cadbury 105G TWISTED BUTTONS 10A	</li>
            <li>	Cadbury 105G DARK MILK BUTTONS 10CA	</li>
            <li>	Cadbury 120G FUDGE BITES 10CA  	</li>
            <li>	110G BOURNVILLE DARK BUTTONS 10CA	</li>
            <li>	Cadbury 100G GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 100G CARAMEL NIBBLES 10CA	</li>
            <li>	Cadbury 100G TWIRL BITES BAG 10CA	</li>
            <li>	Cadbury 100G CRUNCHIE ROCKS 10CA	</li>
            <li>	Cadbury 100G BITSA WISPA BAG 10CA	</li>
            <li>	Cadbury 100G Cadbury ORANGE BUTTONS 10CA	</li>
            <li>	Cadbury 100G OREO BITES 10CA	</li>
            <li>	Cadbury 100G CARAMILK BUTTONS 10CA	</li>
            <li>	Cadbury 100G Cadbury MINT GT BUTTONS 10CA	</li>
            <li>	Cadbury 100G WHITE GIANT BUTNS 10CA	</li>
            <li>	Cadbury 100G CURLYWURLY SQUIRLIES 10CA	</li>
            <li>	Cadbury 100G TWISTED BUTTONS 10CA	</li>
            <li>	Cadbury 100G DARK MILK BUTTONS 10CA	</li>
            <li>	Cadbury 100G FUDGE MINIS 10CA	</li>
            <li>	Cadbury 100G BOURNVILLE BUTTONS 10CA	</li>
            <li>	Cadbury 100G CARAMELEL NIBBLES PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 100G GIANT BUTTONS PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 85G GIANT BUTTONS price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G CARAMEL NIBBLES price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G CARAMILK BUTTON price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G TWIRL BTES price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G BITSA WISPA price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G ORANGE BUTTONS price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G OREO BITES price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G WHITE BUTTONS price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G CURLY WURLY SQUIRLIES price marked pack 169P 10CA	</li>
            <li>	Cadbury 85G GIANT BUTTONS price marked pack 169P PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 85G CARAMEL NIBBLES price marked pack 169P PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 85G GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 85G CARAMEL NIBBLES 10CA	</li>
            <li>	Cadbury 85G TWIRL BITES 10CA	</li>
            <li>	Cadbury 85G BITSA WISPA 10CA	</li>
            <li>	Cadbury 85G Cadbury ORANGE GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 85G WHITE GIANT BUTTONS 10CA	</li>
            <li>	Cadbury 85G CARAMILK BUTTONS 10CA	</li>
            <li>	FRYS 105G TURKISH DELIGHT MINI BARS 20CA	</li>
            <li>	Cadbury 85G GIANT BUTTONS PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 85G CARAMEL NIBBLES PROMO PACK GAME CHANGING WINS 10CA	</li>
            <li>	Cadbury 330G GIANT BUTTONS 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G WINE GUMS 135P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G JELLY BABABIES 135P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G SPORTS MIX 135P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G LIQUORICE ALLSORTS 135P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G MINI GEMS 135P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G FIZZY FISH 135P 12CA	</li>
            <li>	MAYNARDS BASSETTS 350G BAG WINE GUMS 6CA	</li>
            <li>	MAYNARDS BASSETTS 350G JELLY BABIES BAG 6CA	</li>
            <li>	MAYNARDS BASSETTS 350G LIQUORICE ALLSORTS BAG 6CA	</li>
            <li>	MAYNARDS BASSETTS 1KG WINE GUMS 6CA	</li>
            <li>	MAYNARDS BASSETTS 192G SHERBET LEM BAG 12CA	</li>
            <li>	MAYNARDS BASSETTS 193G MURRAY MINT BAG 12CA	</li>
            <li>	MAYNARDS BASSETTS 192G MINT FAVOURITES NEW 12CA	</li>
            <li>	Cadbury 130G ECLAIRS CHOC BAG 12CA	</li>
            <li>	Cadbury 130G ECLAIRS CHOC BAG 1.35P 12CA	</li>
            <li>	TNCC 130G JELLY SNAKES 10CA	</li>
            <li>	TNCC 130G JELLY SQUIRMS 10CA	</li>
            <li>	TNCC 130G DINOSAURS 10CA	</li>
            <li>	SOUR PATCH KIDS 130G ORIGINAL 10CA	</li>
            <li>	SOUR PATCH KIDS 130G FRUIT MIX 10CA	</li>
            <li>	SOUR PATCH KIDS 130G COLA 10CA	</li>
            <li>	SOUR PATCH KIDS 130G WATERMELON 10CA	</li>
            <li>	SOUR PATCH KIDS 130G ORIGIN 150P 10CA	</li>
            <li>	MAYNARDS BASSETTS 130G JELLY BABIES CHICKS 10CA	</li>
            <li>	MAYNARDS BASSETTS 40X45G CHERRY DROPS 6CA	</li>
            <li>	MAYNARDS BASSETTS 52G WINE GUMS ROLL 40CA	</li>
            <li>	MAYNARDS BASSETTS 52G WINE GUMS ROLL price marked pack 40CA	</li>
            <li>	TREBOR 41.3G EXTRA STRONG PEPPERMINT 40CA	</li>
            <li>	TREBOR RLL SOFTMINT PEPPERMINT 40CA	</li>
            <li>	TREBOR RLL SOFTMINT SPEARMINT 40CA	</li>
            <li>	TREBOR 44.9G SOFTMUNT PEPPERMINT 69P 40CA	</li>
            <li>	TREBOR 44G SOFTMINT SPEARRMINT 69P price marked pack 40CA	</li>
            <li>	TREBOR 41.3G EXTRA STRONG PEPPERMINT 69P 40CA	</li>
            <li>	TREBOR 12.6G XS MINI 24CA	</li>
            <li>	TREBOR 12.6G XS MINI 24CA	</li>
            <li>	HALLS 20X32G 12CA	</li>
            <li>	HALLS 20X32G ORIGINAL 12CA	</li>
            <li>	HALLS 20X32G CHERRY 12CA	</li>
            <li>	HALLS 20X33.5G EXTRA 12CA	</li>
            <li>	HALLS 20X45G SOOTH RASPBERRY PEACH 6CA	</li>
            <li>	HALLS 20X45G SOOTH BLACKKCURRANT 6CA	</li>
            <li>	HALLS 20XSTD SOOTH CHERRY 6CA	</li>
            <li>	HALLS 20X45GSOOTH STRAWBERRY 6CA	</li>
            <li>	HALLS SOOTHERS 45G HONEY LEMON 6X20TR	</li>
            <li>	HALLS 32G ORIGINAL 20CA	</li>
            <li>	HALLS 32G CHERRY 20CA	</li>
            <li>	HALLS 33.5G EXTRA STRONG 20CA	</li>
            <li>	HALLS STD SOOTH CHERRY 20CA	</li>
            <li>	HALLS SOOTHERS 45G HONEY LEMON 20CA	</li>
            <li>	HLS STD PK SOOTH BLACKCURRANT 20CA	</li>
            <li>	Cadbury 350G ECLAIRS 6CA	</li>
            <li>	MAYNARDS BASSETS 350G WINE GUMS CARTON 6CA	</li>
            <li>	MAYNARDS BASSETS 350G LIQ ALLSRT CARTON 6CA	</li>
            <li>	MAYNARDS BASSETS 350G JELLY BABIES CARTON 6CA	</li>
            <li>	MAYNARDS BASSETS 350G SPORTS MIX CARTON 6CA	</li>
            <li>	SOUR PATCH KIDS 350G AYR CARTON 6CA	</li>
            <li>	TREBOR 165.2G 4PK EXTRA STRONG PEPPERMINT 12CA	</li>
            <li>	TREBOR 179G 4PK SOFTMINT PPMINT 18CA	</li>
            <li>	TREBOR 179G 4PK SOFTMINT SPEARMINT 18CA	</li>
            <li>	TREBOR 146G 4PK EXTRA STRONG PPMINT 12CA	</li>
            <li>	TREBOR 152G 4PK SOFTMINt PEPPERMINT 18CA	</li>
            <li>	TREBOR 152G 4PK SOFTMINT SPEARMINT 18CA	</li>
            <li>	HALLS 135G TRIPLE SOOTH BLACK CURRANT 9CA	</li>
            <li>	HALLS 180G SOOTH VARIETY 4PK 9CA	</li>
            <li>	TREBOR 44.9G SOFTFRUITS 60P price marked pack 40CA	</li>
            <li>	Green & Blacks ORG FT DARK CHOC 70% 1X15X90G	</li>
            <li>	Green & Blacks ORGANIC MILK 37% FT 1X15X90G	</li>
            <li>	Green & Blacks ORGANIC  HAZELNUT CURRANT 1X15X90G	</li>
            <li>	Green & Blacks'S ORGANIC BUTTERSCOTCH MILK 1X15X90G	</li>
            <li>	Green & Blacks ORGANIC GINGER DARK CHOCOLATE 1X15X90G	</li>
            <li>	Green & Blacks ORGANIC DARK CHOC 85% FT 1X15X90G	</li>
            <li>	Green & Blacks 90G WHITE CHOCOLAT ORGANIC 15CA	</li>
            <li>	Green & Blacks 90G ORGANIC SMOOTH DARK 15CA	</li>
            <li>	Green & Blacks 90G ORGANIC SMOOTH MINT 15CA	</li>
            <li>	Green & Blacks 90G ORGANICSMOOTH 15CA	</li>
            <li>	Green & Blacks 90G ORGANIC SMOOTH MINT 15CA	</li>
            <li>	Green & Blacks 150G ORG FT DARK CKG CHOC 15CA	</li>
            <li>	Cadbury 102G 4PK FLAKE 20CA	</li>
            <li>	Cadbury 129G 3PK TWIRL 12CA	</li>
            <li>	Cadbury 129G 3PK TWIRL ORANGE 12CA	</li>
            <li>	BARNY CHOCOLATE FILLING 125G 7CA	</li>
            <li>	BARNY MILK FILLING 125G 7CA	</li>
            <li>	BARNY 125G CHOCOLATE FILLING 7CA PROMOMOTIONAL PACK	</li>
            <li>	MILKA 39G MILKA 79price marked pack 24CA	</li>
            <li>	MILKA 175G CAKE AND CHOCOLATE 16CA	</li>
            <li>	MILKA 200G CHOCOLATE 16CA	</li>
            <li>	OREO Mini 114g Van 6CA	</li>
            <li>	OREO DOUBLE STUFF 157G X 16	</li>
            <li>	OREO 157G VANILLA LATTE 16CA	</li>
            <li>	OREO 22G VANILLA 6X24 UK	</li>
            <li>	OREO 66G X 20 I.C.	</li>
            <li>	OREO 66G VANILLA 79P price marked pack 20CA	</li>
            <li>	OREO 154G X 16 VANILLA	</li>
            <li>	OREO Twinpack 2x154g Vanilla 8CA	</li>
            <li>	OREO MINECRAFT 154G X 16 VANILLA	</li>
            <li>	OREO MINECRAFT 154G VANILLA 129P 16CA	</li>
            <li>	OREO MINECRAFT Twinpack 2x154g Vanilla 8CA	</li>
            <li>	OREO MINECRAFT 66G X 20 I.C.	</li>
            <li>	OREO 154G BROWNIE 16CA EN	</li>
            <li>	OREO GOLDEN 154g	</li>
            <li>	OREO 154g Birthday Party 16CA	</li>
            <li>	OREO 154G VANILLA 129P 16CA	</li>
            <li>	OREO 154G GOLDEN price marked pack 129P 16CA	</li>
            <li>	OREO 157G DOUBLE CREAM 129P 16CA	</li>
            <li>	OREO 132g Vanilla Lunchbox	</li>
            <li>	OREO 400G VANILLA CRUMB 12CA UK	</li>
            <li>	OREO 400G CRMB NOCRE 12CA	</li>
            <li>	OREO 400g Van Crumb Natural 12CA	</li>
            <li>	OREO 400G CRUMBS 12CA UK	</li>
            <li>	OREO 4-10MM 260KG 1BB	</li>
            <li>	OREO CRUMB TAPAS 13KG	</li>
            <li>	OREO 246G WHITE CHOCO 10CA	</li>
            <li>	OREO Yard 440G	</li>
            <li>	OREO 170G SELECTION BOX 8CA	</li>
            <li>	OREO 154G GINGERBREAD 16CA	</li>
            <li>	RITZ 150G ORIGINAL 8CA	</li>
            <li>	RITZ 140G CHEESE 8CA	</li>
            <li>	RITZ 150G ORIGINAL 149P 8CA	</li>
            <li>	MINI RITZ 150G X 12	</li>
            <li>	Ritz Breaks Original 190G X 8	</li>
            <li>	Cadbury SANDWICH 260g 18 CA	</li>
            <li>	Cadbury 114G MILK FINGERS 20CA	</li>
            <li>	Cadbury 114G FINGERS WHITE 20CA	</li>
            <li>	Cadbury 114G SALTED CARAMEL FINGERS 20CA	</li>
            <li>	Cadbury 114G ORANGE FING 20CA	</li>
            <li>	Cadbury 189G MILK FINGERS 14CA	</li>
            <li>	Cadbury 114G FINGERS 165P price marked pack 12CA	</li>
            <li>	Cadbury 40G MINI FINGERS 16CA CDU	</li>
            <li>	Cadbury 114G MILK FINGERS 20CA PROMO	</li>
            <li>	Cadbury 114G FINGERS WHITE 20CA PROMO	</li>
            <li>	Cadbury 114G SALTED CARAMEL FINGERS 20CA PROMO	</li>
            <li>	Cadbury 189G MILK FINGERS 14CA PROMO	</li>
            <li>	Cadbury 114G FINGER 165P price marked pack 12CA PROMO	</li>
            <li>	Cadbury 96.5G MINI FINGERS 8CA	</li>
            <li>	Cadbury 99.5G MINI ANIMALS 8CA	</li>
            <li>	Cadbury 96.5G MINI FINGERS 8CA PROMO	</li>
            <li>	Cadbury 99.5G MINI ANIMALS 8CA PROMO	</li>
            <li>	Cadbury 125G MINI FINGER POUCH 8CA	</li>
            <li>	Cadbury 125G Nibbly Fingers Pouches 40CA	</li>
            <li>	Cadbury 135gx24 CHOCOLATE	</li>
            <li>	Cadbury ROUNDIE 150G MLK 14CA	</li>
            <li>	Cadbury CRUNCHY MELTS CHOC 156G	</li>
            <li>	Cadbury CRUNCHY MELTS CHOC 312G 12 CA	</li>
            <li>	Cadbury 312G CRUNCHY MELT OREO 12CA	</li>
            <li>	Cadbury 156G CRUNCHY MELTS CHC 165P 12CA	</li>
            <li>	Cadbury 40G SGL SNACK SCAKE 36CA	</li>
            <li>	Cadbury 120G 6PK SNACK  24CA	</li>
            <li>	Cadbury 132G 6P SANDWICH 34CA	</li>
            <li>	Cadbury 140G BRUNCH CHOCHIP 8CA	</li>
            <li>	Cadbury 140G BRUNCH BOURNVILLE 8CA	</li>
            <li>	Cadbury 140G BRUNCH PEANUT 8CA	</li>
            <li>	Cadbury 140G BRUNCH RAISIN 8CA	</li>
            <li>	Cadbury 130G BRUNCH OATS & HONEY 8CA	</li>
            <li>	Cadbury 130G BRUNCH ORANGE 8CA	</li>
            <li>	Cadbury 140G BRUNCH CHOCOLATE CHIP price marked pack 8CA	</li>
            <li>	Cadbury 108G 6PK Timeout 13CA	</li>
            <li>	Cadbury 108G 6PK Timeout ORANGE 13CA	</li>
            <li>	Cadbury 18G Timeout 40CA	</li>
            <li>	Cadbury 115G FINGERS SNOWY 20CA	</li>
            <li>	Cadbury 119G FESTIVE ANIM 8CA	</li>
            <li>	COCOA CHOC CHIP 225G	</li>
            <li>	GOLDEN OATS 225G	</li>
            <li>	BELVITA MINIS 210G HONEY & NUT 12CA	</li>
            <li>	REDUCED SUGAR 225G	</li>
            <li>	BELVITA 225G HONEY NUT price marked pack 10CA	</li>
            <li>	BELVITA 225G HONEY NUT 10CA	</li>
            <li>	BELVITA 225G CEREALS AND MILK 10CA	</li>
            <li>	BELVITA 225G HONEY NUT 10CA PROMO	</li>
            <li>	BELVITA 225G CEREALS AND MILK 10CA PROMO	</li>
            <li>	BELVITA 225G COCOA CHOCO CHIP 10CA PROMO	</li>
            <li>	BELVITA 540G HONEY NUT 5CA	</li>
            <li>	BELVITA 540G CEREALS AND MILK 5CA	</li>
            <li>	BELVITA DUO CRUNCH STRAWBERRY 253G X 8	</li>
            <li>	BELVITA 253G SAND DUO STRAWB YOG 8CA PROMO	</li>
            <li>	BELVITA STANDARD YOGURT 253G X 8	</li>
            <li>	BELVITA BAKED BAR CHOC & HAZELNUT 160G	</li>
            <li>	BELVITAV 160G BAR DARK CHOC&ORANGE 10CA	</li>
            <li>	BELVITA SOFT BAKES GOLD	</li>
            <li>	BELVITA SOFT BAKES RED BERRIES	</li>
            <li>	BELVITA SOFT BAKES BLUEBERRY	</li>
            <li>	BELVITA 250G SOFT BAKES CHOC CHIP 6CA	</li>
            <li>	BELVITA 250G SOFT CHOCO 6CA	</li>
            <li>	BELVITA SOFT FILLED STRAWBERRY	</li>
            <li>	BELVITA 250G SOFT APRICOT 6CA	</li>
            <li>	BELVITA SOFT BAKES CHOC CHIP 250g £1.99 price marked pack	</li>
            <li>	BELVITA 250G SOFT BAKES CHOC CHIP 6CA PROMO	</li>
            <li>	BELVITA 250G SOFT CHOCOLATE 6CA PROMO	</li>
            <li>	BELVITA 250G SOFT STRAWBERRY 6CA PROMO	</li>
            <li>	Bournville 50G SOFT CHOC CHIP 20CA	</li>
            <li>	BELVITA 50G HONEY NUT 20CA	</li>
            <li>	BELVITA 50G SOFT CHOC CHIP 69P price marked pack 20CA	</li>
            <li>	BELVITA STRAW DUO I.C. 50.6G X 18	</li>
            <li>	LU Petit Citron 140g 7CA	</li>
            <li>	PECO PECHOC 100G MILK20CA	</li>
            <li>	LU Le Petit Cookie 184G 8CA	</li>
            <li>	LU Petit Beurre 167g 7CA	</li>
            <li>	PECO PECHOC 100G MILK20CA price marked pack	</li>
            <li>	MB Wine Gum 130g Juicies	</li>
            <li>	MB Wine Gums 165g	</li>
            <li>	MB Sports Mix 165g	</li>
            <li>	SPK Original 130g	</li>
            <li>	Cadbury Drinking Choc  12x175G	</li>
            <li>	Cadbury Drinking Choc 299P 6x250G	</li>
            <li>	Cadbury Drinking Choc  6x250G	</li>
            <li>	Cadbury Drinking Choc  12x250G	</li>
            <li>	Cadbury Drinking Choc  6x450G EDLP SKU	</li>
            <li>	Cadbury Drinking Choc  6x450G LIDL copack	</li>
            <li>	Cadbury Drinking Choc  6x500G	</li>
            <li>	Cadbury Drinking Choc  6x750G	</li>
            <li>	Cadbury Drinking Choc  6x1KG Comp	</li>
            <li>	Cadbury Drinking Choc  6x2KG Comp	</li>
            <li>	Cadbury Drinking Choc  1x5KG Pail	</li>
            <li>	Cadbury 250G COMP COCOA FT 6CA	</li>
            <li>	Cadbury 250G COMP COCOA FT 12CA	</li>
            <li>	Cadbury 154G HIGHLIGHTS CHOC 6CA	</li>
            <li>	Cadbury 180G HIGHLIGHTS CHOC 6CA	</li>
            <li>	Cadbury 11G HLGHTS STICK PACK 30CA	</li>
            <li>	Cadbury INSNT JAR FT 12X300G	</li>
            <li>	Cadbury INSNT JAR FT 6X300G	</li>
            <li>	Cadbury 250G INSTANTS 6CA	</li>
            <li>	Cadbury 250G INSTANTS 339P price marked pack 6CA	</li>
            <li>	Cadbury INSTANT COMP 6x2KG	</li>
            <li>	Cadbury10X1KG BAG INSTCHOC ONE	</li>
            <li>	Cadbury 28G INSTANTS STICK PACK 30CA	</li>
            <li>	Cadbury 28G INSTANTS STICK PACK 50CA AFH	</li>
            <li>	Green & Blacks 125G COCOA FT 6CA	</li>
            <li>	Green & Blacks 250G ORG DRINK CHOC FT 6CA	</li>
            {
              showTargetDateOne && (
                <>
                  <li>Cadbury Dairy Milk Iced Latte Bar 122.5G</li>
                  <li>Cadbury Dairy Milk Iced Latte Bar 122.5G £1.69</li>
                </>
              )
            }
            {
              showTargetDateTwo && (
                <>
                  <li>Maynards Bassetts Classic Fruit Mix 110g</li>
                  <li>Maynards Bassetts Classic Fruit Mix 110g £1.35</li>
                </>
              )
            }
          </ul>
        </div>
      </div>
    </section>
  </>;
}